import { createSelector } from "reselect";
import { Roles } from "./auth.types";
export const getAuthState = (state) => state.auth;
export const isAuthenticatedSelector = createSelector(getAuthState, (state) => state.isAuthenticated || false);
export const userInfoSelector = createSelector(getAuthState, (state) => state.user);
export const usernameSelector = createSelector(userInfoSelector, (user) => user?.name ?? "");
export const roleSelector = createSelector(userInfoSelector, (user) => user?.role || Roles.User);
